<section class="bg-(--color-secondary) py-6 md:py-8">
  <div class="px-7 grid grid-cols-1 md:grid-cols-2 gap-5 items-stretch max-w-6xl mx-auto">
    <!-- form content -->
    <div class="contact-form pt-10">
      <h3 class="p-6 md:p-8">أرسل لنا رسالة</h3>
      @if (contactForm) {
        <form class="px-6 pb-6 md:px-8 md:pb-8" [formGroup]="contactForm" (ngSubmit)="onSubmit()">
          <div class="mb-4">
            <label for="full_name" class="block mb-2 text-sm font-medium text-(#333333)">
              الإسم بالكامل
            </label>
            <input
              formControlName="full_name"
              type="text"
              id="full_name"
              class="w-full h-10 rounded-md border border-(--color-secondary) px-3 focus:outline-none focus:border-(--color-secondary)"
            />
            @if (contactForm.get('full_name')?.errors && contactForm.get('full_name')?.touched) {
              <div
                class="flex p-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 mt-2"
                role="alert"
              >
                <ul class="mt-1.5 ml-4 list-disc list-inside">
                  @if (contactForm.get('full_name')?.errors?.['required']) {
                    <li>برجاء إدخال الاسم بالكامل</li>
                  } @else if (contactForm.get('full_name')?.errors?.['pattern']) {
                    <li>اكتب الاسم ثلاثي على الأقل (4 كلمات)</li>
                  } @else if (contactForm.get('full_name')?.errors?.['maxlength']) {
                    <li>الاسم طويل جدًا</li>
                  }
                </ul>
              </div>
            }
          </div>

          <div class="mb-4">
            <label for="phone" class="block mb-2 text-sm font-medium text-(#333333)">
              رقم الهاتف
            </label>
            <input
              formControlName="phone"
              type="tel"
              id="phone"
              class="w-full h-10 rounded-md border border-(--color-secondary) px-3 focus:outline-none focus:border-(--color-secondary)"
            />
            @if (contactForm.get('phone')?.errors && contactForm.get('phone')?.touched) {
              <div
                class="flex p-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 mt-2"
                role="alert"
              >
                <ul class="mt-1.5 ml-4 list-disc list-inside">
                  @if (contactForm.get('phone')?.errors?.['required']) {
                    <li>برجاء إدخال رقم الهاتف</li>
                  } @else if (contactForm.get('phone')?.errors?.['pattern']) {
                    <li>اكتب رقم بصيغة دولية مثل: +2010xxxxxxxx</li>
                  }
                </ul>
              </div>
            }
          </div>

          <div class="mb-4">
            <label for="email" class="block mb-2 text-sm font-medium text-(#333333)">
              البريد الإلكترونى
            </label>
            <input
              formControlName="email"
              type="email"
              id="email"
              class="w-full h-10 rounded-md border border-(--color-secondary) px-3 focus:outline-none focus:border-(--color-secondary)"
            />
            @if (contactForm.get('email')?.errors && contactForm.get('email')?.touched) {
              <div
                class="flex p-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 mt-2"
                role="alert"
              >
                <ul class="mt-1.5 ml-4 list-disc list-inside">
                  @if (
                    contactForm.get('email')?.errors?.['required'] &&
                    contactForm.get('email')?.touched
                  ) {
                    <li>برجاء ادخال البريد الالكتروني</li>
                  } @else if (contactForm.get('email')?.errors?.['email']) {
                    <li>لبريد الإلكتروني غير صالح</li>
                  }
                </ul>
              </div>
            }
          </div>




<div class="mb-4">
  <label
    for="message_type"
    class="block mb-2 text-sm font-medium text-(#333333)"
  >
    {{ languageService.getLang() === 'ar' ? 'نوع الإستفسار' : 'Inquiry Type' }}
  </label>

  <select
    formControlName="message_type"
    id="message_type"
    class="w-full h-10 rounded-md border border-(--color-secondary) px-3 focus:outline-none focus:border-(--color-secondary)"
  >
    @for (type of messageTypes; track type.value) {
      <option [value]="type.value">
        {{ getMessageTypeLabel(type) }}
      </option>
    }
  </select>
</div>

          <div class="mb-4">
            <label for="message" class="block mb-2 text-sm font-medium text-(#333333)">
              الرسالة
            </label>
            <textarea
              formControlName="message"
              id="message"
              rows="5"
              class="w-full rounded-md border border-(--color-secondary) px-4 py-3 resize-none focus:outline-none focus:border-(--color-secondary)"
            ></textarea>
            @if (contactForm.get('message')?.errors && contactForm.get('message')?.touched) {
              <div
                class="flex p-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 mt-2"
                role="alert"
              >
                <ul class="mt-1.5 ml-4 list-disc list-inside">
                  @if (contactForm.get('message')?.errors?.['required']) {
                    <li>برجاء كتابة الرسالة</li>
                  } @else if (contactForm.get('message')?.errors?.['minlength']) {
                    <li>الرسالة يجب أن تكون 10 أحرف على الأقل</li>
                  }
                </ul>
              </div>
            }
          </div>

          <div class="flex justify-start">
            <button
              type="submit"
              class="bg-(--color-main) text-(#132951) px-10 h-11 rounded-md font-semibold cursor-pointer"
            >
              إرسال الرسالة
            </button>
          </div>
        </form>
      }
    </div>

    <!-- info content -->
    <div class="contact-info">
      <div class="info-header">
        <span class="text-(--color-main)">
          <svg class="w-5 h-5" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6 4l6 6-6 6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          معلومات التواصل
        </span>

        <h3 class="text-(--color-main)">تواصل معنا مباشرة</h3>

        <p class="text-white py-4">
          نحن هنا لمساعدتك. تواصل معنا عبر أي من القنوات التالية أو أرسل لنا <br />رسالة وسنرد عليك
          في أقرب وقت.
        </p>
      </div>

      <!-- cards container -->
      <div class="mt-6 space-y-4">
        <!-- card 1 -->
        <div
          class="flex items-center justify-between gap-4 bg-(--color-main) rounded-2xl px-6 py-4"
        >
          <span
            class="icon-box w-12 h-12 rounded-lg bg-(--color-secondary) flex items-center justify-center"
          >
            <i class="fa-solid fa-location-dot text-(--color-main) text-[20px]"></i>
          </span>

          <div class="contact-text flex-1">
            <h4>العنوان</h4>
            <p>1 حافظ رمضان</p>
            <p>القاهرة</p>
          </div>
        </div>
        <!-- card 2 -->
        <div
          class="flex items-center justify-between gap-4 bg-(--color-main) rounded-2xl px-6 py-4"
        >
          <span
            class="icon-box w-12 h-12 rounded-lg bg-(--color-secondary) flex items-center justify-center shrink-0"
          >
            <img src="/icons/telephone.svg" class="w-5 h-5 text-(--color-main)" alt="Telephone" />
          </span>
          <div class="contact-text flex-1">
            <h4>الهاتف</h4>
            <p>01208122221</p>
          </div>
        </div>
        <!-- card 3 -->
        <div
          class="flex items-center justify-between gap-4 bg-(--color-main) rounded-2xl px-6 py-4"
        >
          <span
            class="icon-box w-12 h-12 rounded-lg bg-(--color-secondary) flex items-center justify-center shrink-0"
          >
            <img src="/icons/email.svg" class="w-5 h-5 text-(--color-main)" alt="Email" />
          </span>
          <div class="contact-text flex-1">
            <h4>البريد الإلكترونى</h4>
            <p>info@awalan.com</p>
            <p>support@awalan.com</p>
            <p>brokers@awalanagri.com</p>
          </div>
        </div>
        <!-- card 4 -->

        <div
          class="flex items-center justify-between gap-4 bg-(--color-main) rounded-2xl px-6 py-4"
        >
          <span
            class="icon-box w-12 h-12 rounded-lg bg-(--color-secondary) flex items-center justify-center shrink-0"
          >
            <i class="fa-regular fa-clock text-(--color-main) text-[20px]"></i>
          </span>
          <div class="contact-text flex-1">
            <h4>ساعات العمل</h4>
            <p>الأحد - الخميس: 9 صباحاً - 6 <br />مساءً</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
